import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryPrioritytSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <g clipPath="url(#clip0_6525_104469)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.128 15.821L17.083 12.74L17.041 21.934C17.0405 22.0747 17.0122 22.2139 16.9578 22.3436C16.9034 22.4734 16.824 22.5911 16.7241 22.6901C16.6241 22.7891 16.5056 22.8675 16.3754 22.9206C16.2451 22.9738 16.1057 23.0008 15.965 23C15.8244 22.9993 15.6853 22.971 15.5557 22.9165C15.426 22.8621 15.3084 22.7826 15.2095 22.6827C15.1106 22.5828 15.0323 22.4643 14.9792 22.3341C14.9261 22.204 14.8992 22.0646 14.9 21.924L14.941 12.732L11.865 15.772C11.7652 15.8711 11.6469 15.9495 11.5168 16.0028C11.3867 16.0562 11.2474 16.0833 11.1068 16.0828C10.9661 16.0822 10.827 16.054 10.6973 15.9996C10.5677 15.9452 10.45 15.8659 10.351 15.766C10.1512 15.5641 10.0397 15.2911 10.041 15.007C10.0423 14.723 10.1563 14.4511 10.358 14.251L15.407 9.25098C15.5728 9.08709 15.7968 8.99576 16.0299 8.99707C16.263 8.99838 16.4861 9.09224 16.65 9.25798L21.65 14.311C21.8497 14.5127 21.9612 14.7855 21.9599 15.0694C21.9586 15.3533 21.8446 15.6251 21.643 15.825C21.5433 15.9242 21.425 16.0029 21.2949 16.0564C21.1647 16.1099 21.0254 16.1372 20.8847 16.1369C20.744 16.1365 20.6047 16.1084 20.4749 16.0542C20.3451 16 20.2272 15.9208 20.128 15.821Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_6525_104469">
            <rect width="14" height="14" fill="white" transform="translate(9 23) rotate(-90)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default TaskHistoryPrioritytSVG;
